import { z } from 'zod';
import { PartialIndividualLineItemSchema } from './IndividualLineItemSchema';

export const IndividualLineItemListingFormSchema = z.object({
    items: z.array(PartialIndividualLineItemSchema).min(1),
});
